export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f1f901cfa140b23ee31fdb47705e12b5fbc5520e6&name=fetchTypeahead!'